import React from "react"
import parse from "html-react-parser"

const percent = (num, sub, sup) => {
  const a = num.match("%")
  const b = num.split(a)
  if (sub) {
    return (
      <div className="blockNumber-container-number">
        {sub ? (
          <>
            {b}
            <sub>{sub}</sub>
          </>
        ) : (
          <>{b}</>
        )}

        <span>{a}</span>
      </div>
    )
  }
  if (sup) {
    return (
      <div className="blockNumber-container-number">
        {sup ? (
          <>
            {b}
            <sup>{sup}</sup>
          </>
        ) : (
          <>{b}</>
        )}

        <span>{a}</span>
      </div>
    )
  } else {
    return (
      <div className="blockNumber-container-number">
        <>{b}</>

        <span>{a}</span>
      </div>
    )
  }
}

const bottom = (cont, sub, lang, normal) => {
  const a = cont.match(/[^\d/]+\/?|\//g)
  const b = cont.match(/\d+/g)
  return (
    <>
      {normal === true ? (
        <div className="blockNumber-container-bottomText">{parse(cont)}</div>
      ) : (
        <>
          {sub ? (
            <div className="blockNumber-container-bottomText">
              {lang === "en" ? (
                <>
                  {a[0]} <sub>{b}</sub> {a[1]}
                </>
              ) : (
                <>
                  {" "}
                  {a} <sub>{b}</sub>
                </>
              )}
            </div>
          ) : (
            <div
              className={
                lang === "eus"
                  ? "blockNumber-container-bottomText " + lang
                  : "blockNumber-container-bottomText"
              }
            >
              {a} {b}
            </div>
          )}
        </>
      )}
    </>
  )
}

const BlockNumber = ({ topText, num, bottomText, sub, sup, lang, normal }) => (
  <div
    className={
      lang === "eng" ? "blockNumber-container " + lang : "blockNumber-container"
    }
  >
    <div className="blockNumber-container-topText">{topText}</div>
    {percent(num, sub, sup)}
    {bottom(bottomText, sub, lang, normal)}
  </div>
)
export default BlockNumber
